import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { PromoCodeDiscountType } from 'src/app/shared/models/promo-code-discount-type.enum';
import { PromoCodeService } from '../../../services/promo-code.service';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
    selector: 'promo-code-create-modal',
    templateUrl: './promo-code-create-modal.component.html',
    styleUrl: './promo-code-create-modal.component.scss',
    standalone: false,
    providers: [provideNativeDateAdapter()]
})
export class PromoCodeCreateModalComponent extends BaseModalComponent implements OnInit {
  DiscountType = PromoCodeDiscountType;
  public form: FormGroup = new FormGroup({
    code: new FormControl('',{
      validators: Validators.required
    }),
    discountType: new FormControl(PromoCodeDiscountType.Percentage, {
      validators: Validators.required
    }),
    discountAmount: new FormControl('', {
      validators: Validators.required
    }),
    startDate: new FormControl(null, {
      validators: Validators.required
    }),
    endDate: new FormControl(null, {
      validators: Validators.required
    }),
    startTimeOnly: new FormControl('09:00'),
    endTimeOnly: new FormControl('17:00'),
    usageLimit: new FormControl(null),
    isActive: new FormControl(true)
  });

  constructor(
    private promoCodeService: PromoCodeService,
    protected sessionService: SessionService,
    public dialogRef: MatDialogRef<PromoCodeCreateModalComponent>
  ) {
    super();
  }

  ngOnInit() {
    // Get current date and set time to 9:00 AM
    const now = new Date();
    now.setHours(9, 0, 0, 0); // Set to 9:00:00.000
    
    const localDateTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
    
    this.form.patchValue({
      startDate: localDateTime
    });
  }

  submit({value, valid}) {
    if (valid) {
      this.isLoading = true;
      value.organizationId = this.sessionService.getUser().organizationId;
      value.createdBy = this.sessionService.getUserId();
      value.startDate = new Date(value.startDate.getFullYear(), value.startDate.getMonth(), value.startDate.getDate(), value.startTimeOnly.getHours(), value.startTimeOnly.getMinutes(), value.startTimeOnly.getSeconds());
      value.endDate = new Date(value.endDate.getFullYear(), value.endDate.getMonth(), value.endDate.getDate(), value.endTimeOnly.getHours(), value.endTimeOnly.getMinutes(), value.endTimeOnly.getSeconds());

      this.promoCodeService.create(value).subscribe({
        next: (result) => {
          this.dialogRef.close('save');
        },
        error: (error) => {
          console.error(error);
          this.isLoading = false;
          this.setErrorV2(error, this.form);
        },
        complete: () => this.isLoading = false
      });
    }
  }
}
